export default __webpack_public_path__ + "static/media/icon_sorting-ascending.d800e77d.svg";